// extracted by mini-css-extract-plugin
export default {"bubble":"cERGdn","content":"Wi_s5V","triangleWrapper":"x7XlNO","arrowleft":"XNJAa3","triangle":"yl6xpz"};